import { FC } from 'react';
import { useWindowSize } from '@shared/utils/hooks';
import breakpoint from '../../../../shared/assets/breakpoint.json';
import SkeletonRecipeThumb from '../recipe/thumbnail/RecipeThumb';
import { Container, Content, Cover, RecipeThumbS, RecipeThumbSWrapper, RecipeThumbWrapper, RightContent, SkeletonMenuAmount, SkeletonTitle, Title } from './NewCollection.style';
const SkeletonNewCollection: FC = () => {
  const {
    width
  } = useWindowSize();
  const renderMobileLayout = () => {
    return <Container>
                <Cover>
                    <Content>
                        <Title>
                            <SkeletonMenuAmount active />
                            <SkeletonTitle active />
                            <SkeletonTitle active />
                        </Title>
                        <RecipeThumbSWrapper>
                            <RecipeThumbS />
                            <RecipeThumbS />
                            <RecipeThumbS />
                        </RecipeThumbSWrapper>
                    </Content>
                </Cover>
            </Container>;
  };
  const renderTabletLayout = () => {
    return <Container>
                <Cover>
                    <Content>
                        <Title>
                            <SkeletonMenuAmount active />
                            <SkeletonTitle active />
                            <SkeletonTitle active />
                        </Title>
                        <RecipeThumbSWrapper>
                            <RecipeThumbS />
                            <RecipeThumbS />
                            <RecipeThumbS />
                        </RecipeThumbSWrapper>
                    </Content>
                </Cover>

                <RightContent>
                    <RecipeThumbWrapper>
                        <SkeletonRecipeThumb />
                    </RecipeThumbWrapper>
                    <RecipeThumbWrapper>
                        <SkeletonRecipeThumb />
                    </RecipeThumbWrapper>
                    <RecipeThumbWrapper>
                        <SkeletonRecipeThumb />
                    </RecipeThumbWrapper>
                </RightContent>
            </Container>;
  };
  const renderContent = () => {
    if (width > breakpoint.lg - 1) {
      return <Container>
                    <Cover>
                        <Content>
                            <Title>
                                <SkeletonMenuAmount active />
                                <SkeletonTitle active />
                                <SkeletonTitle active />
                            </Title>
                            <RecipeThumbSWrapper>
                                <RecipeThumbS />
                                <RecipeThumbS />
                                <RecipeThumbS />
                            </RecipeThumbSWrapper>
                        </Content>
                    </Cover>

                    <RightContent>
                        <SkeletonRecipeThumb />
                        <SkeletonRecipeThumb />
                        <SkeletonRecipeThumb />
                        <SkeletonRecipeThumb />
                    </RightContent>
                </Container>;
    }
    if (width > breakpoint.md) {
      return renderTabletLayout();
    }
    return renderMobileLayout();
  };
  return renderContent();
};
export default SkeletonNewCollection;